import React from 'react';
import 'date-fns';

import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import API from '../../services/api';
import CustomAlert from '../custom/alert';

export default function DialogChangePassword({ children, ...props }) {
  const id = Number(API.encryptedSessionStorage.getItem('id', API.encryptedSessionStorage.getTokenData().uid));
  const initialState = {};
  const load = React.useRef(true);
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const { open, setOpen } = props;
  const [state, setState] = React.useState(initialState);

  function reset() {
    setState(initialState);
  }

  function handleCancel(event) {
    event.preventDefault();
    setOpen(false);
    reset();
  }

  function handleConfirm(event) {
    event.preventDefault();
    const min = 5;
    if (Number(state.password.trim().length) < min) {
      setAlert({ open: true, message: `Sua deve ter pelo menos ${min} caracteres válidos.` });
      return;
    }
    API.Users.update(id, { password: state.password }).then(onSuccess).catch(onFailure);
    setOpen(false);
    reset();
  }

  function onSuccess(response) {
    if (load.current && response.data) {
      setAlert({ open: true, message: 'Sua senha foi atualizada com sucesso!' });
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      console.log(error.message);
      // setAlert({ open: true, message: error.message });
      setAlert({ open: true, message: 'Não foi possível atualizar sua senha, por favor, tente novamente mais tarde.' });
    }
  }

  const handleChangeState = () => (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
        {alert.message}
      </CustomAlert>

      <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{props.title || 'Alterar Senha'}</DialogTitle>
        <DialogContent>
          <InputLabel htmlFor="standard-adornment-password">{'Digite sua nova senha'}</InputLabel>
          <Input
            autoFocus
            id="standard-adornment-password"
            name="password"
            type={state.showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            required={false}
            value={state.password}
            onChange={handleChangeState(false, false, false)}
            fullWidth={true}
            endAdornment={
              <InputAdornment position="end" fullWidth={true}>
                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                  {state.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {'Cancelar'}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
